import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PillFilterComponent } from '@shared/components/pill-filter/pill-filter.component';
import { SharedModule } from '@shared/modules/shared.module';

/**
 * One of the filters drawn as a pill above the table.
 *
 * Same field contract as `app-filter`, so a screen can pass the same fields
 * to both places without translating anything.
 */
export interface InlineFilterField {
	key: string;
	/** Label and option labels are shown as is: the caller passes them already translated */
	label: string;
	type: 'select' | 'date' | 'text' | 'tabs' | 'datepicker' | 'multiselect';
	options?: { label: string; value: any }[];
	defaultValue?: any;
	placeholder?: string;
	filter?: boolean;
	filterPlaceholder?: string;
}

/**
 * Inline filters for the table header.
 *
 * Each one is an `app-pill-filter`: a light pill with the label that, once a
 * value is picked, shows a dark chip inside with the value and its X. It is the
 * almaisel component, not a disguised select.
 */
@Component({
	selector: 'app-inline-filters',
	imports: [SharedModule, PillFilterComponent],
	templateUrl: './inline-filters.component.html',
	styleUrl: './inline-filters.component.scss',
})
export class InlineFiltersComponent {
	@Input() filters: InlineFilterField[] = [];
	@Input() values: Record<string, any> = {};

	@Output() filterChange = new EventEmitter<{ key: string; value: any }>();

	onValueChange(key: string, value: any): void {
		this.filterChange.emit({ key, value });
	}
}
